import { Typography as MUITypo } from '@material-ui/core'
import { TypographyProps } from '@material-ui/core/Typography'
import React from 'react'
import styled from '../../../../../theme'

const Typography: React.ComponentType<TypographyProps> = styled(MUITypo)<
  TypographyProps
>`
  && {
    font-family: Montserrat;
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.1px;
    text-align: left;
    color: #323232;
  }
`

export default Typography
